import React, { useState } from "react";
import { PRIMARY_FIELDS } from "./constants";
import FieldEditor from "./FieldEditor";

const EditConfigs = ({
  configs,
  updateType,
  setUpdateType,
  updateTarget,
  setUpdateTarget,
  selectedLogins,
  setSelectedLogins, // ✅ باید این prop رو هم اضافه کنیم
  toggleLoginSelection,
  isActiveChange,
  setIsActiveChange,
  availableRiskFields,
  availablePipFields,
  availableTtlFields,
  riskConfigChanges,
  setRiskConfigChanges,
  pipConfigChanges,
  setPipConfigChanges,
  ttlConfigChanges,
  setTtlConfigChanges,
  additionalFieldsChanges,
  setAdditionalFieldsChanges,
  availableAdditionalFields,
  handleUpdateConfigs,
  resetEditForm,
  updateLoading,

}) => {
  const [manualLogin, setManualLogin] = useState("");

  const addManualLogin = () => {
    const loginValue = manualLogin.trim();
    if (loginValue && !selectedLogins.includes(loginValue)) {
      toggleLoginSelection(loginValue);
      setManualLogin("");
    }
  };

  const removeLogin = (login) => {
    toggleLoginSelection(login);
  };

  // ✅ تابع انتخاب/حذف همه - نسخه جدید
  const toggleSelectAll = () => {
    if (!configs || configs.length === 0) return;
    
    if (selectedLogins.length === configs.length) {
      // اگر همه انتخاب شده‌اند، همه رو حذف کن
      setSelectedLogins([]);
    } else {
      // اگر نه، همه رو انتخاب کن
      const allLogins = configs.map(config => config.login);
      setSelectedLogins(allLogins);
    }
  };

  // چک کردن وضعیت انتخاب همه
  const isAllSelected = configs && configs.length > 0 && 
                        selectedLogins.length === configs.length;
  
  const isSomeSelected = selectedLogins.length > 0 && 
                         configs && 
                         selectedLogins.length < configs.length;

  return (
    <div className="space-y-6">
      {/* انتخاب نوع به‌روزرسانی */}
      <div className="bg-gray-800 border border-purple-600 rounded-lg p-4 space-y-4">
        <h4 className="text-white font-medium">نوع به‌روزرسانی</h4>
        <div className="space-y-3">
          <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
            <input
              type="radio"
              name="updateType"
              value="all_individuals"
              checked={updateType === "all_individuals"}
              onChange={(e) => setUpdateType(e.target.value)}
              className="w-5 h-5 accent-purple-600"
            />
            <div>
              <div className="text-white font-medium">همه حساب‌های فردی</div>
              <div className="text-gray-400 text-sm">
                تغییرات برای تمام Individuals اعمال می‌شود
              </div>
            </div>
          </label>

          <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
            <input
              type="radio"
              name="updateType"
              value="all_groups"
              checked={updateType === "all_groups"}
              onChange={(e) => setUpdateType(e.target.value)}
              className="w-5 h-5 accent-purple-600"
            />
            <div>
              <div className="text-white font-medium">همه گروه‌ها</div>
              <div className="text-gray-400 text-sm">
                تغییرات برای تمام Groups اعمال می‌شود
              </div>
            </div>
          </label>

          <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
            <input
              type="radio"
              name="updateType"
              value="custom_logins"
              checked={updateType === "custom_logins"}
              onChange={(e) => setUpdateType(e.target.value)}
              className="w-5 h-5 accent-purple-600"
            />
            <div>
              <div className="text-white font-medium">انتخاب دستی Login ها</div>
              <div className="text-gray-400 text-sm">
                تغییرات فقط برای Login های انتخاب شده اعمال می‌شود
              </div>
            </div>
          </label>
        </div>

        {updateType === "custom_logins" && (
          <div className="bg-gray-900 rounded-lg p-4 border-t border-gray-600">
            <label className="block text-white font-medium mb-3">
              نوع حساب برای Login های انتخابی:
            </label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="updateTarget"
                  value="individuals"
                  checked={updateTarget === "individuals"}
                  onChange={(e) => setUpdateTarget(e.target.value)}
                  className="w-5 h-5 accent-green-600"
                />
                <span className="text-white">Individuals</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="updateTarget"
                  value="groups"
                  checked={updateTarget === "groups"}
                  onChange={(e) => setUpdateTarget(e.target.value)}
                  className="w-5 h-5 accent-green-600"
                />
                <span className="text-white">Groups</span>
              </label>
            </div>
          </div>
        )}
      </div>

      {updateType === "custom_logins" && (
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4 space-y-4">
          <h4 className="text-white font-medium">
            انتخاب حساب‌ها برای ویرایش
          </h4>

          {/* افزودن دستی Login */}
          <div className="bg-gray-700 rounded-lg p-4">
            <label className="block text-white text-sm font-medium mb-2">
              افزودن Login به صورت دستی:
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                value={manualLogin}
                onChange={(e) => setManualLogin(e.target.value)}
                placeholder="شماره Login را وارد کنید..."
                className="flex-1 p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-green-500 focus:outline-none"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addManualLogin();
                  }
                }}
              />
              <button
                type="button"
                onClick={addManualLogin}
                disabled={!manualLogin.trim()}
                className="px-4 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white rounded-lg transition duration-200 whitespace-nowrap"
              >
                افزودن
              </button>
            </div>
          </div>

          {/* لیست انتخاب */}
          {configs && configs.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-3">
                <label className="block text-white text-sm font-medium">
                  یا از لیست انتخاب کنید:
                </label>
                
                {/* ✅ Checkbox انتخاب همه */}
                <label className="flex items-center gap-2 cursor-pointer bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded-lg transition">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    ref={(input) => {
                      if (input) {
                        input.indeterminate = isSomeSelected;
                      }
                    }}
                    onChange={toggleSelectAll}
                    className="w-5 h-5 accent-purple-600"
                  />
                  <span className="text-white font-medium text-sm">
                    {isAllSelected 
                      ? `حذف همه (${configs.length})` 
                      : `انتخاب همه (${configs.length})`
                    }
                  </span>
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-h-96 overflow-y-auto bg-gray-900 p-3 rounded-lg">
                {configs.map((config) => (
                  <label
                    key={config.login}
                    className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition"
                  >
                    <input
                      type="checkbox"
                      checked={selectedLogins.includes(config.login)}
                      onChange={() => toggleLoginSelection(config.login)}
                      className="w-5 h-5 accent-green-600"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-white font-medium truncate">
                        Login: {config.login}
                      </div>
                      <div className="text-gray-400 text-sm truncate">
                        {config.login_name || "—"}
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* Login های انتخاب شده */}
          {selectedLogins.length > 0 && (
            <div className="bg-gray-900 rounded-lg p-3">
              <p className="text-gray-300 text-sm mb-2">
                Login های انتخاب شده ({selectedLogins.length} مورد):
              </p>
              <div className="flex flex-wrap gap-2">
                {selectedLogins.map((login) => (
                  <div
                    key={login}
                    className="bg-green-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                  >
                    {login}
                    <button
                      type="button"
                      onClick={() => removeLogin(login)}
                      className="hover:bg-green-700 rounded-full p-1 transition duration-200"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* فرم ویرایش */}
      <div className="bg-gray-800 border border-yellow-600 rounded-lg p-6 space-y-6">
        <h4 className="text-lg font-semibold text-white border-b border-gray-600 pb-3">
          تغییرات مورد نظر
        </h4>

        {/* تغییر وضعیت */}
        <div>
          <label className="block text-white font-medium mb-2">
            تغییر وضعیت (اختیاری):
          </label>
          <select
            value={isActiveChange || ""}
            onChange={(e) => setIsActiveChange(e.target.value || null)}
            className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
          >
            <option value="">بدون تغییر</option>
            <option value="true">فعال</option>
            <option value="false">غیرفعال</option>
          </select>
        </div>

        {/* Risk Config */}
        {availableRiskFields && availableRiskFields.length > 0 && (
          <div>
            <label className="block text-white font-medium mb-2">
              تغییرات Risk Config:
            </label>
            <FieldEditor
              availableFields={availableRiskFields}
              changes={riskConfigChanges}
              onChange={setRiskConfigChanges}
              highlightFields={[...PRIMARY_FIELDS.drawdown, ...PRIMARY_FIELDS.monitoring]}
            />
          </div>
        )}

        {/* Pip Config */}
        {availablePipFields && availablePipFields.length > 0 && (
          <div>
            <label className="block text-white font-medium mb-2">
              تغییرات Pip Config:
            </label>
            <FieldEditor
              availableFields={availablePipFields}
              changes={pipConfigChanges}
              onChange={setPipConfigChanges}
              highlightFields={PRIMARY_FIELDS.pip}
            />
          </div>
        )}

        {/* TTL Config */}
        {availableTtlFields && availableTtlFields.length > 0 && (
          <div>
            <label className="block text-white font-medium mb-2">
              تغییرات TTL Config:
            </label>
            <FieldEditor
              availableFields={availableTtlFields}
              changes={ttlConfigChanges}
              onChange={setTtlConfigChanges}
              highlightFields={PRIMARY_FIELDS.ttl}
            />
          </div>
        )}

        {/* Additional Fields */}
        {availableAdditionalFields && availableAdditionalFields.length > 0 && (
          <div>
            <label className="block text-white font-medium mb-2">
              تغییرات فیلدهای اضافی:
            </label>
            <FieldEditor
              availableFields={availableAdditionalFields}
              changes={additionalFieldsChanges}
              onChange={setAdditionalFieldsChanges}
              highlightFields={[]}
            />
          </div>
        )}

        {/* دکمه‌ها */}
        <div className="flex gap-3 pt-4 border-t border-gray-600">
          <button
            onClick={resetEditForm}
            className="flex-1 py-3 px-6 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition duration-200"
          >
            پاک کردن فرم
          </button>
          <button
            onClick={handleUpdateConfigs}
            disabled={updateLoading || (updateType === "custom_logins" && selectedLogins.length === 0)}
            className="flex-1 py-3 px-6 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
          >
            {updateLoading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                در حال ذخیره...
              </>
            ) : (
              "ذخیره تغییرات"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditConfigs;